var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMainList,
                expression: "showMainList"
              }
            ],
            staticClass: "main-content",
            attrs: { type: "primary" }
          },
          [
            _c(
              "search-item",
              {
                attrs: {
                  "config-module": "210102",
                  reset: true,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  )
                },
                on: {
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c("el-input", {
                  staticStyle: { width: "100%" },
                  attrs: { slot: "customType1", value: _vm.fileCategoryLabel },
                  nativeOn: {
                    click: function($event) {
                      _vm.fileTypeEditor.visible = true
                    }
                  },
                  slot: "customType1"
                }),
                _c("el-input-number", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    slot: "customType2",
                    "controls-position": "left",
                    controls: false
                  },
                  slot: "customType2",
                  model: {
                    value: _vm.pageSize,
                    callback: function($$v) {
                      _vm.pageSize = $$v
                    },
                    expression: "pageSize"
                  }
                }),
                _c(
                  "template",
                  { slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.batchDowloadHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BatchDownload")))]
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "42010101",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "deselect-sub-record": true
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.searchLob,
              "file-id": _vm.fileTypeEditor.fileId,
              "file-category": _vm.documentType
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.changeFileType
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "pagination-wrapper" }, [
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              staticStyle: { "text-align": "left" },
              attrs: { total: _vm.total, layout: "total" }
            })
          ],
          1
        )
      ]),
      _c(
        "form",
        {
          ref: "downloadForm",
          staticStyle: { display: "none" },
          attrs: {
            action: _vm.submitForm.url,
            target: "_blank",
            method: "post"
          }
        },
        _vm._l(_vm.submitForm.formEntries, function(item) {
          return _c("input", {
            key: decodeURIComponent(item[0]),
            attrs: { name: decodeURIComponent(item[0]) },
            domProps: { value: decodeURIComponent(item[1]) }
          })
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }